import React from 'react';

import {
  SiOrcid,
  SiGooglescholar,
  SiGithub,
  SiMastodon,
  SiResearchgate
} from "react-icons/si";
import { FaLinkedin } from "react-icons/fa";
import { MdEmail } from 'react-icons/md'; 

const footerStyle = {
  padding: '20px 0',
  textAlign: 'center',
  marginTop: '30px',
  borderTop: '1px solid var(--border-color)' // Use CSS variable for border
};

const iconStyle = {
  margin: '0 10px',
  fontSize: '2em',
  verticalAlign: 'middle'
  // Color is handled by SCSS: var(--footer-icon-color) and var(--footer-icon-hover-color)
};

function Footer() {
  return (
    // Removed className="bg-light"
    // Border color will now be controlled by CSS variable if defined in footerStyle or main.scss
    <footer style={footerStyle}>
      <div className="container">
        <a href="https://www.linkedin.com/in/klesel/" target="_blank" rel="noopener noreferrer" style={iconStyle} className="social-icon-link" aria-label="LinkedIn">
          <FaLinkedin />
        </a>
        <a href="https://github.com/Klesel" target="_blank" rel="noopener noreferrer" style={iconStyle} className="social-icon-link" aria-label="GitHub">
          <SiGithub />
        </a>
        <a href="https://scholar.google.com/citations?user=KV23qFwAAAAJ&hl=de&oi=ao" target="_blank" rel="noopener noreferrer" style={iconStyle} className="social-icon-link" aria-label="Google Scholar">
          <SiGooglescholar />
        </a>
        <a href="mailto:websitecontact@klesel.info" style={iconStyle} className="social-icon-link" aria-label="Email">
          <MdEmail />
        </a>
        <a href="https://fosstodon.org/@Klesel" target="_blank" rel="noopener noreferrer" style={iconStyle} className="social-icon-link" aria-label="Mastodon">
          <SiMastodon />
        </a>
        <a href="https://orcid.org/0000-0002-2884-1819" target="_blank" rel="noopener noreferrer" style={iconStyle} className="social-icon-link" aria-label="ORCID">
          <SiOrcid />
        </a>
        <a href="https://www.researchgate.net/profile/Michael-Klesel-2" target="_blank" rel="noopener noreferrer" style={iconStyle} className="social-icon-link" aria-label="ResearchGate">
          <SiResearchgate />
        </a>
      </div>
      <div className="text-center mt-3">
        {/* This text will use var(--text-color) */}
        <p>&copy; {new Date().getFullYear()} Michael Klesel. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;